import { render, staticRenderFns } from "./GGanttGrid.vue?vue&type=template&id=12655e1a&scoped=true"
import script from "./GGanttGrid.vue?vue&type=script&lang=js"
export * from "./GGanttGrid.vue?vue&type=script&lang=js"
import style0 from "./GGanttGrid.vue?vue&type=style&index=0&id=12655e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12655e1a",
  null
  
)

export default component.exports